import type { IconProps } from './types'

export const PeopleIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <circle cx="9" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M4 20C4.2 17 6.2 15 9 15C11.8 15 13.8 17 14 20"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="15" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M10 20C10.2 17 12.2 15 15 15C17.8 15 19.8 17 20 20"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default PeopleIcon
